<template>
  <div class="container page lottery" style="width: 100%; padding-bottom:0px; background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;">
    <div style="width: 100%;position: relative;z-index: 2;background-color: rgb(244, 44, 124)"><van-nav-bar :title="$t('auth.top44')" class="nav-bar" style="height: 46px;line-height: 46px">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
        <template #right>
           <div class="right" @click="$router.push({path:'/Bookinglist'});">{{ $t('auth.top4') }}</div> 
       </template>
    </van-nav-bar></div>
<div style="width: 100%;padding: 40px 20px 31px 20px;">
	<div style="position: relative;width: 100%;height: 136px;background: url(/img/home/1.png) no-repeat 100%/100%;">
		<div style="font-weight: bold;font-size: 16px;line-height: 22px;color: rgb(146, 103, 249);font-style: italic;position: absolute;left: 15px;top: 15px;">
			{{this.userInfo.lv_name}} 
		</div>
		<div style="background-image: linear-gradient(to right, rgb(222, 225, 255), rgb(252, 243, 251), rgb(252, 230, 248));
    padding: 2px 10px;
    border-radius: 52px;
    color: rgb(154, 138, 174);
    position: absolute;
    left: 78px;
    top: 15px;
    font-size: 12px;">
			{{ $t('auth.top5') }}
		</div>
		<div style="color: rgb(154, 138, 174);
    font-size: 14px;
    position: absolute;
    left: 15px;
    top: 67px;">{{ $t('auth.top6') }}:{{this.userInfo.order}} </div>
	</div>
	<div style="background-color: rgb(245, 247, 251);
    display: flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 52px;width: 100%;">
	<van-image style="width: 26px;
    height: 26px;" src="/img/home/a.png"></van-image>
	<div style="text-align: center;
    flex: 1 1 0%;
    color: rgb(145, 148, 155);font-size: 14px;">今年最も人気のあるホテル</div>
	</div>
	<div style="display: flex;
    align-items: center;
    padding: 15px 0px 7px;width: 100%;">
		<van-image style="margin-right: 5px; width: 10px; height: 15px;" src="/img/home/b.png"></van-image>
		<div style=" font-weight: bold">{{ $t('auth.top7') }}</div>
	</div>
	<div style="display: flex;
    justify-content: space-between;">
		<div style="display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 49%;
    height: 192px;
    background: url(/img/home/card_bg.f1192da5.png) no-repeat;
    background-size: 100% 192px;">
			<div style="margin: 0 13px;
    font-size: 13px;
    color: #878a91;
    line-height: 14px;">{{ $t('auth.top8') }}</div>
	<div style="margin: 2px 13px 13px;
    font-size: 20px;
    font-weight: 900;
    color: #333;
    line-height: 28px;">
		{{ this.userInfo.money }}
	</div>
		</div>
		<div style="display: flex;
    flex-direction: column;
    width: 49%;">
			<div style="display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 90px;
    background: url(/img/home/card_bg2.9586d924.png) no-repeat;
    background-size: 100% 90px;">
			<div style="margin: 0 13px;
    font-size: 13px;
    color: #878a91;
    line-height: 14px;">
				{{ $t('auth.top9') }}
			</div>
			<div style="margin: 2px 13px 13px;
    font-size: 20px;
    font-weight: 900;
    color: #333;
    line-height: 28px;">
				{{this.userInfo.commission}}
			</div>
		</div>
		<div style="    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin: 11px 0 0;
    height: 90px;
    background: url(/img/home/card_bg3.8c0bc8cd.png) no-repeat;
    background-size: 100% 90px;">
		<div style="margin: 0 13px;
    font-size: 13px;
    color: #878a91;
    line-height: 14px;">
			{{ $t('auth.top10') }}/{{ $t('auth.top11') }}
		</div>
		<div style="margin: 2px 13px 13px;
    font-size: 20px;
    font-weight: 900;
    color: #333;
    line-height: 28px;">
			{{this.userInfo.order}}/{{this.userInfo.order_num}}
		</div>
	</div>
		</div>
	</div>
	
	<div style="border: 0.5px solid rgb(244, 44, 124);
    padding: 10px;
    margin: 20px 0px;
    border-radius: 10px;">
		<div style="font-size: 12px;
    color: rgb(145, 148, 155);">
			{{ $t('auth.top23') }}
		</div>
		<div style="font-weight: bold;
    font-size: 14px;
    color: rgb(51, 51, 51);
    margin-top: 2px;">
			{{this.userInfo.yongjin}}%
		</div>
	</div>
	
	<div style="border: 0.5px solid rgb(244, 44, 124);
	padding: 10px;
	margin: 20px 0px;
	border-radius: 10px;">
		<div style="font-size: 12px;
	color: rgb(145, 148, 155);">
			{{ $t('auth.top12') }}
		</div>
		<div style="font-weight: bold;
	font-size: 14px;
	color: rgb(51, 51, 51);
	margin-top: 2px;">
			{{this.userInfo.order}}/{{this.userInfo.order_num}}
		</div>
	</div>
	
	<div style="border: 0.5px solid rgb(244, 44, 124);
	padding: 10px;
	margin: 20px 0px;
	border-radius: 10px;">
		<div style="font-size: 12px;
	color: rgb(145, 148, 155);">
			{{ $t('auth.top13') }}
		</div>
		<div style="font-weight: bold;
	font-size: 14px;
	color: rgb(51, 51, 51);
	margin-top: 2px;">
			{{this.userInfo.order_num}}
		</div>
	</div>
	
	<div style="position: relative;
    display: block;padding-left: 14px;
    padding-right: 14px;
    box-sizing: border-box;text-align: center;
    text-decoration: none;height: 42px;line-height: 42px;
    font-size: 14px;
    font-weight: 500;border-radius: 5px;
    color: #fff;
    background: linear-gradient(180deg, #fc78af, #f22678);
    border: none;"  @click="jiesuan()">
		{{ $t('auth.top14') }}
	</div>
</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,userInfo:{
      },
    };
  },
  methods: {
    back() {
      return window.history.back();
    },getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {this.kefu = res.data.kefu;
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
            console.log(this.userInfo);
            this.menu_top = 15;
            if(this.userInfo.status !== 1){
              this.$toast(this.$t("video.account_out"));
              localStorage.clear()
              this.$router.push({path:'/Login'})
            }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }, jiesuan() {
	this.$http({
	method: "post",
	data: {
	},
	url: "get_rot_order",
	}).then((res) => {
	if (res.code === 200) {
	this.$toast(this.$t("auth.top26"));this.$router.push({path:'/Bookinglist'})
	} else if (res.code === 401) {
	this.$toast(res.msg);
	}else if(res.code===300){
	this.$toast(this.$t("auth.top24"));
	}else if(res.code===201){
	this.$toast(this.$t("auth.top25"));
	}else if(res.code===500){
	this.$toast(this.$t("auth.top26"));
	}
	});
	}
  },created() {this.getBasicConfig();
    if(localStorage.getItem('token')){
        this.getUserInfo();
    }else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  },computed: {
     
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #fff;
  font-size: 28px;
  border-radius: 10px;
 
  line-height: 60px;
}
.lottery {
  background: url("/img/lotterybg.png") no-repeat
    top;
  background-size: contain;
}
.lottery .van-nav-bar {
  background:none;
}
.record {
  padding-left: 20px;
  padding-right: 20px;
  box-shadow: 0 4px 4px 0 #cacaca;
  z-index: 1;
}
.record .period {
  display: flex;
  align-items: center;
  padding: 10px 0 0 0;
}
.record .period .cover {
  width: 104px;
  height: 104px;
  -o-object-fit: cover;
  object-fit: cover;
}
.record .period .period-number {
  flex: 1;
  margin-left: 40px;
  margin-right: 20px;
  height: 50px;
  line-height: 50px;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
}
.van-count-down {
  color: #f4d70a;
  font-size: 45px;
  margin-top: 10px;
  float: right;
}
.linear-gradient {
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));

}
.record .recent {
  display: flex;
  align-items: center;
  height: 110px;
}
.kuaisan-ball .left {
  justify-content: flex-start;
}
.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle {
  width: 15%;
  font-size: 35px;
}
.van-icon {
  font-size: 40px;
}
.down {
  transition: all 0.5s;
}
.up {
  transform: rotate(180deg);
  transition: all 0.5s;
}
.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}
.options-bar {
  display: flex;
  align-items: center;
  height: 100%;
 
}
.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.options-bar .game .tips {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}
.options-bar .game .tips .odds {
  flex: 1;
  font-size: 35px;
  font-weight: 500;
  color: #ff253f;
}
.options-bar .game .tips .play-tip {
  display: flex;
  align-items: center;
  height: 100%;
}
::v-deep .van-icon-more-o {
  color: #ff253f;
  font-size: 50px;
}
.options-bar .game .tips .play-tip .span-text {
  margin-left: 10px;
  font-size: 35px;
  font-weight: bolder;
  color: #ff253f;
}
.linear-gradient {
  width: 100%;
  height: 2px;
}
.sumValueTwoSides {
  display: flex;
  padding: 30px 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.rectangle {
  overflow: hidden;
}
.rectangle.large {
  width: calc(50% - 7vw) !important;
    height: 21vw !important;
    line-height: 21vw;
    text-align: center;
    background: #fff;
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, .1);
    margin: 0 0 4vw 4%;
    width: 20%;
    border-radius: 20px;
}
.rectangle .wrapper {
  position: relative;
  padding: 0 10px;
  background: #fff;
}
.rectangle .wrapper .content {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.rectangle.large .wrapper {
  padding-bottom: 100%;
}
.rectangle .wrapper .content .name-text.large {
  font-size: 32px;
}
.rectangle .wrapper .content .name-text {
  color: #7d7c7c;
 
}
.rectangle .wrapper .content .odd-text.large {
  font-size: 25px;
  margin-top: -30px;
}
.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: #ff253f;
}.van-toast{
	
}
.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 100px;
  z-index: 2;
}
.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-color: #fff;
  box-shadow: 0 0 20px 0 #cacaca;
  z-index: 2;
}
.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar .left .item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  font-size: 20px;
}
.bottom-bar .bar .left .item .text {
  font-size: 22px;
  color: #7d7c7c;
}
.jixuanico {
  font-size: 45px;
}
.bottom-bar .bar .left .line {
  width: 2px;
  height: 50px;
  background: #dadada;
}
.bottom-bar .bar .mid {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.bottom-bar .bar .mid .text {
  font-size: 30px;
  font-weight: 500;
  color: #000;
}
.bottom-bar .bar .mid .text.num {
  margin: 0 5px;
  color: #ff253f;
}
.bottom-bar .bar .right {
  padding: 0 10px;
  margin: 0 30px;
  color: #fff;
  background: linear-gradient(180deg, #fc78af, #f22678);
  font-size: 28px;
  font-weight: 500;
  height: 70px;
  line-height: 70px;
  border-radius: 16px;
}
.rectangle.active .wrapper {
  background-color: #ff253f !important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}
::v-deep .van-popup {
  position: absolute;
}
::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}
::v-deep .van-popup--top {
  top: -1px;
}
.wrapper .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.wrapper .item .left {
  width: 30%;
  font-size: 30px;
  text-align: center;
  font-weight: 500;
  color: #000;
}
.font-weight {
  font-weight: 700 !important;
}
.wrapper .item .right {
  flex: 1;
  display: flex;
  font-size: 30px;
  justify-content: center;
  overflow: hidden;
  color: #000;
}
.wrapper .item .kuaisan-ball .left {
  justify-content: flex-start;
}
.wrapper .item .kuaisan-ball {
  margin-left: 20px;
  flex: 1;
  display: flex;
  align-items: center;
}
.wrapper .item .kuaisan-ball .res-img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
.wrapper .item .kuaisan-ball .res-des {
  background: linear-gradient(180deg, #fc78af, #f22678);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    margin-right: 30px;
    width: 7vw;
    border-radius: 50%;
}
.middle{
  border-radius: 16px;
  padding: 0 16px;
  background: linear-gradient(180deg, #fc78af, #f22678);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    margin-right: 30px;
}

.play-type-tip {
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 700px;
  max-height: 50%;
  z-index: 10;
  border-radius: 30px;
  overflow: hidden;
  background-color: #fff;
  color: #000;
}
.play-type-tip .title {
  line-height: 90px;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: 500;
}
.mask {
  background-color: rgba(0, 0, 0, 0);
  animation-duration: 0.35s;
}
.play-type-tip .wrapper {
  height: calc(100% - 10px);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.play-type-tip .wrapper .item {
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
}
.play-type-tip .wrapper .item .van-icon {
  color: #e6c3a1;
  font-size: 60px;
}
.play-type-tip .wrapper .item .content .content-title {
  margin-top: 22px;
  font-size: 35px;
  font-weight: 500;
  color: #000;
  line-height: 0px;
}
.play-type-tip .wrapper .item .content .content-detail {
  margin-top: 5px;
  font-size: 22px;
  color: #000;
  line-height: 30px;
}
.play-type-tip .wrapper .item .content {
  flex: 1;
  margin-left: 30px;
}
.rectangle.active .wrapper {
  background:linear-gradient(180deg, #fc78af, #f22678) !important;
}
.rectangle.active .wrapper .name-text,
.rectangle.active .wrapper .odd-text {
  color: #fff !important;
}
.bottom-bar .wrapper {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  height: 180px;
  background-color: #fff;
  z-index: 1;
  box-shadow: 0 0 10px 0 #cacaca;
  transition: transform 0.3s cubic-bezier(0.21, 1.02, 0.55, 1.01);
}
.bottom-bar .wrapper.active {
  transform: translateY(-100%);
}
.bottom-bar .wrapper .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
}
.bottom-bar .wrapper .item .label {
  font-size: 30px;
  line-height: 30px;
  color: #000;
}
.bottom-bar .wrapper .item .bet-number {
  flex: 1;
  margin: 0 16px;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #ed37ae;
  font-size: 30px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
}
.bottom-bar .wrapper .item .amount-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.van-cell {
  font-size: 30px;
  line-height: 50px;
}
.bottom-bar .wrapper .item .part {
  margin-right: 20px;
}
.bottom-bar .wrapper .item .part span {
  font-size: 30px;
  vertical-align: center;
  color: #000;
}
.bottom-bar .wrapper .item .part .number {
  margin: 0 5px;
  color: #ff253f;
  font-weight: 500;
}
::v-deep .van-field__control {
  color: #ff253f;
}
.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 0px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 30px;
}
.confirm-order-modal .head {
  position: relative;
  height: 80px;
}
.confirm-order-modal .head .text {
  padding: 0 20px;
  height: 30px;
  line-height: 10px;
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  color: #7e5678;
}
::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 2px;
}
.van-popup--center {
  border-radius: 30px;
}
.confirm-order-modal .list {
  flex: 1;
  padding: 0 30px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}
.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: 35px;
  font-weight: 500;
  line-height: 0px;
  word-wrap: break-word;
  word-break: break-all;
}
.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 0px;
  font-size: 25px;
  color: #979799;
}
.confirm-order-modal .list .lise-item {
  color: #ff253f;
}
.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}
.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}
.confirm-order-modal .sub-bar .item.cancel-btn {
  border: 2px solid #666;
  color: #000;
  background-color: #fff;
}
.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(20deg, #8673e5, #d958a4);
  color: #fff;
  border: 0;
}
.next-number span {
  font-size: 35px;
  font-weight: 700;
  color: #000;
  float: right;
}
.numberBox .resBox{
  display: flex;
    align-items: center;
    background: none;
    border-radius: 16px;
    padding: 16px;
    height: 100%;
    margin-left: 10px;
    width: calc(100% - 37vw);
    box-sizing: border-box;
}
.resBox .resItem{
  width: 9vw;
    height: 9vw;
    line-height: 9vw;
    margin-right: 20px;
    background:linear-gradient(180deg, #fc78af, #f22678);
    border-radius: 50%;
    color: #fff;
    text-align: center
}
.ressquareBox{
  border-radius: 16px;
  padding: 0 16px;
  background: linear-gradient(180deg, #fc78af, #f22678);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
}
.ballBox{
	border: 1px solid #606060;
  color: #606060;
    font-weight: 700;
    margin-right: 8px;
    font-size: 20px;width:40px
}
.list{
 padding: 4vw;
}
.list .item{
  background-color: #e4e4e7;
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 20px;
}
</style>
